module.exports = __webpack_public_path__ + "static/qualite-d1af2e87553216ba426fb65e453b2ff9.jpg";